//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    whosFoot: {
      default: "",
    },
    footData: {
      default: "",
    },
  },
  computed: {
    footYStyle() {
      return {
        transform: `translateY(${this.footData.y}px)`,
        transition: this.footData.transitionY,
      };
    },
    footXStyle() {
      return {
        transform: `translateX(${this.footData.x}px`,
        transition: this.footData.transitionX,
      };
    },
    footOtherStyle() {
      return {
        transform: `rotate(${this.footData.rotation}deg)`,
        transformOrigin: this.footData.origin,
        transition: this.footData.transitionOther,
        opacity: this.footData.isStanding ? 1 : 0.3,
      };
    },
    footOffset() {
      switch (this.whosFoot) {
        case "ML":
          return "";
        case "MR":
          return "";
        case "LL":
          return "";
        case "LR":
          return "";
        default:
          return "";
      }
    },
    footSrc() {
      switch (this.whosFoot) {
        case "ML":
          return "ML.svg";
        case "MR":
          return "MR.svg";
        case "LL":
          return "LL.svg";
        case "LR":
          return "LR.svg";
        default: 
          return "";
      }
    },
  },
  data() {
    return {
      standing: true,
      doneMovingY: true,
      doneMovingX: true,
    };
  },
};
